export default __webpack_public_path__ + "static/media/f_container.6aecc223.svg";